import React, { Component, Fragment } from 'react';
import { string, number, object, shape, arrayOf, any, bool, func, objectOf } from 'prop-types';
import cx from 'classnames';
import ChannelsPieChart from './ChannelsChart';
import ChannelsTable from './ChannelsTable';
import KeywordTable from '../../Keyword';
import  { shapeOfKeywordData } from '../../Keyword/constant';
import ChannelsBarChart from '../../HorizontalBarChart';
import ModuleExport from '../../ModuleExport';
import DeleteReportItemButton from '../../DeleteReportItem';
import ShowAllAds from '../../Modal/ShowAllAds';
import { advertiserShape } from '../../../helpers/propTypes';
import { get } from 'lodash';
import { FormControl, Select, MenuItem } from '@material-ui/core';
import { defaultChartSelector } from '../../../helpers/defaultInfo';
import {
  SINGLE_PAGE_WEB_ANALYTICS_DATA,
  MIN_LENGTH_TRAFFIC_CHANNEL_DATA,
  INFO,
  NOTE,
  TRACKING_SOURCE_NAME,
} from '../../../helpers/constant';
import { getNumberOfChartAndTableInReport } from '../Report/helper';
import {
  checkEnableFeatureFlag,
  getEnabledFlags,
  getChannelHashmapByCondition,
  getChannelDataHashmapByCondition,
  getKeywordDataHashmapByConditions,
  getChannelCsvDataHashmapByCondition,
  shouldShowTabDisclaimer,
  shouldShowTileByDateCompare,
  shouldShowNewAdUserSunsetDisclaimer,
} from '../../../helpers/common';
import {
  COMMON_NUMBER_TABLE_ROWS_TO_TRUNCATE,
  KEYWORD_CHART_ID,
  TRAFFIC_CHANNEL_CHART_ID,
  newAdUsersMetricKey,
  newAdUsersKey,
  avgAdCostKey
} from '../../../helpers/constant';
import {
  CHANNEL_TABLE_HASHMAP,
  KEYWORD_TABLE_HASHMAP,
  CHANNEL_CSV_HASHMAP,
  DEFAULT_KEYWORD_DISPLAY_COLUMNS,
  INIT_NEW_AD_USERS_PER_AD_SORT,
  INIT_NEW_AD_USERS_SORT,
} from './constants';

import styles from './styles.scss';
import MessageWithStatus from '../../MessageWithStatus';
import DeprecatedDataDisclaimer from '../TabDisclaimer/DeprecatedDataDisclaimer';
import ga4OnlyStyles from '../TabDisclaimer/styles.scss';

const defaultDataType = get(defaultChartSelector, [TRAFFIC_CHANNEL_CHART_ID, 'adVisits']);
export class ChannelsAnalytics extends Component {
  static propTypes = {
    title: string,
    fileName: string,
    data: arrayOf(shape({
      trafficType: string,
      ads: number,
      adVisit: number,
      adUser: number,
      avgAdCost: number,
      visitOfAds: number
    })),
    keywordData: arrayOf(shapeOfKeywordData),
    dropDownOptions: shape({
      label: string,
      value: string
    }),
    classes: shape({any}),
    advertiser: advertiserShape.isRequired,
    campaign: shape({
      chartData: object,
      campaign_id: number
    }),
    isAvgCostDisabled: bool,
    showKeywordTable: bool,
    totalAds: number,
    avgAdCost: number,
    redirectToCampaignTabs: func,
    inpdf: bool,
    pageNumber: number,
    page: number,
    // for drilldown
    notifications: shape({any}),
    urlApi: objectOf(string),
    currentPayload: shape({
      advertiserId: number,
      campaignId: number,
      tab: string
    }),
    hideChannelFields: bool,
    hideChannelFieldsForPdf: bool,
    setChartSelector: func,
    selectionType: string,
    keywordSelectionType: string,
    columnColors: objectOf(string),
    isCustomReport: bool,
    inTabReport: bool,
    showInReportConfig: shape({
      trafficChannelsChart: bool,
      trafficChannelsTable: bool,
      keywordReportTable: bool,
    }),
    countInReportConfig: shape({
      trafficChannelsChart: arrayOf(number),
      trafficChannelsTable: arrayOf(number),
      keywordReportTable: arrayOf(number),
    }),
    channelChartSelectors: arrayOf(objectOf(string)),
    keywordChartSelectors: arrayOf(objectOf(string)),
    setReportChartSelector: func,
    currentStep: string,
    trafficTableSortSelector: shape({
      sortKey: string,
      sortType: string,
    }),
    keywordTableSortSelector: shape({
      sortKey: string,
      sortType: string,
    }),
    beginKeyword: number,
    isNewAdUsersEnabled: bool,
    setReportTableSortSelector: func,
    isShouldShowSunsetDisclaimer: bool,
    isGbqEnabled: bool,
    isHiddenChart: bool,
    isTableOnly: bool,
    rowOnFirstPage: number,
    endOfTable: bool
  }

  static defaultProps = {
    title: 'Traffic Channels',
    fileName: 'traffic_channel_analytics_chart',
    dropDownOptions: {
      adVisits: {
        label: 'Ad Visits',
        key: 'adVisits'
      },
      avgAdCost: {
        label: 'Avg. Ad Cost',
        key: 'avgAdCost'
      },
      newAdUsers: {
        label: 'New Ad Users',
        key: newAdUsersKey
      },
    },
    selectionType: 'adVisits',
    showInReportConfig: {},
    countInReportConfig: {
      trafficChannelsChart: [1],
      trafficChannelsTable: [1],
      keywordReportTable: [1],
    },
    columnColors: {
      ['Direct']: '#5397D8',
      ['Referral']: '#5C75D8',
      ['Display']: '#7E6AD7',
      ['Paid Search']: '#A869D8',
      ['Email']: '#EA63A9',
      ['Social']: '#E965CB',
      ['Organic search']: '#D167D8',
      ['Other']: '#EB6288',
      ['Mobile Push Notifications']: '#DC6788',
      ['SMS']: '#DC6967',
      ['Paid Social']: '#DC8C67',
      ['Paid Shopping']: '#DCD267',
      ['Paid Other']: '#DCAF67',
      ['Organic Video']: '#C3DC67',
      ['Organic Shopping']: '#A0DC67',
      ['Cross-network']: '#7DDC67',
    },
    isShouldShowSunsetDisclaimer: false,
  }

  state = {
    isDrillDownOpen: false,
    drillDownInfo: {},
  }

  handleCellClick = (data) => {
    const { campaign, urlApi, isCustomReport } = this.props;
    if (isCustomReport) {
      return;
    }
    const { trafficId } = data;
    const trafficIds = trafficId && [ trafficId ] || [];
    const drillDownInfo = {
      urlApi,
      campaignId: get(campaign, 'campaign_id'),
      trafficIds
    };
    this.setState({
      isDrillDownOpen: true,
      drillDownInfo
    })
  }

  handleDrillDownClose = () => {
    const { redirectToCampaignTabs, currentPayload } = this.props;
    const { advertiserId, campaignId, tab } = currentPayload;
    redirectToCampaignTabs(advertiserId, campaignId, tab);
    this.setState({
      isDrillDownOpen: false,
      drillDownInfo: {}
    });
  };

  handleTypeChange = (selectorIndex, chartId) => (e) => {
    const {
      setChartSelector,
      campaign,
      setReportChartSelector,
      setReportTableSortSelector,
      isCustomReport
    } = this.props;
    const campaignId = campaign.campaign_id;
    const newType = e.target.value;
    setChartSelector && setChartSelector(
      campaignId,
      chartId,
      { type: newType }
    );
    isCustomReport
    && setReportChartSelector
    && setReportChartSelector(chartId, selectorIndex, {
      type: newType });

    /* handle table selector */
    const { isHideChannelFields } = this.channelConditions;
    const isKeywordReport = chartId === KEYWORD_CHART_ID;
    if (newType === newAdUsersKey) {
      setReportTableSortSelector(
        chartId,
        selectorIndex,
        isKeywordReport ? INIT_NEW_AD_USERS_SORT : isHideChannelFields ? INIT_NEW_AD_USERS_SORT : INIT_NEW_AD_USERS_PER_AD_SORT,
      );
    }
  }

  prepChartData(channelChartSelectorType) {
    const { data, dropDownOptions, selectionType, columnColors } = this.props;
    const chartSelectorType = channelChartSelectorType || selectionType;
    const { key, label } = get(dropDownOptions, [chartSelectorType], {});
    const chartData = data && data.reduce((accum, currentEntry) => {
      if (chartSelectorType === avgAdCostKey) {
        const { trafficType } = currentEntry;
        if (trafficType) {
          accum.push({
            y: trafficType,
            x: currentEntry[key] && currentEntry[key].toFixed(2),
            fillColor: columnColors[trafficType]
          })
        }
        return accum;
      } else {
        const { trafficType } = currentEntry;
        if (trafficType) {
          const value = currentEntry[key] || 0;
          accum.push({ trafficType, value });
        }
        return accum;
      }
    }, []);

    return { chartData, valueLabel: label, valueKey: key };
  }

  drawDropDown(selectorIndex, channelChartSelectorType, handleTypeChange, isKeywordTable) {
    const { dropDownOptions, classes, selectionType } = this.props;
    const conditions = { 
      ...this.channelConditions,
      isKeywordTable,
    };
    const filterDropDownOptions = getChannelHashmapByCondition(dropDownOptions, conditions);
    const dropDownOptionList = Object.values(filterDropDownOptions);
    const chartId = isKeywordTable ? KEYWORD_CHART_ID : TRAFFIC_CHANNEL_CHART_ID;

    return (
      <FormControl className={styles.dropDown}>
        <Select
          value={channelChartSelectorType || selectionType}
          className={styles.selector}
          onChange={handleTypeChange(selectorIndex, chartId)}
          inputProps={{ classes: { icon: classes.arrowDropDown } }}
        >
          {
            dropDownOptionList.map(item => (
              <MenuItem
                value={item.key}
                key={item.key}
              >
                {item.label}
              </MenuItem>
            ))
          }
        </Select>
      </FormControl>
    );
  }

  get channelConditions() {
    const {
      isAvgCostDisabled,
      hideChannelFields,
      hideChannelFieldsForPdf,
      isNewAdUsersEnabled
    } = this.props;
    const isHideChannelFields = hideChannelFields || hideChannelFieldsForPdf;
    const conditions = {
      isAvgCostDisabled,
      isNewAdUsersEnabled,
      isHideChannelFields
    }
    return conditions;
  }

  exportContainer = React.createRef();
  render() {
    const {
      title,
      fileName,
      data,
      isAvgCostDisabled,
      inpdf,
      page,
      pageNumber,
      campaign,
      advertiser,
      notifications,
      totalAds,
      avgAdCost,
      showKeywordTable,
      hideChannelFields,
      hideChannelFieldsForPdf,
      selectionType,
      keywordSelectionType,
      isCustomReport,
      showInReportConfig,
      currentStep,
      countInReportConfig,
      channelChartSelectors,
      keywordChartSelectors,
      trafficTableSortSelector,
      keywordTableSortSelector,
      beginKeyword,
      keywordData,
      inTabReport,
      isShouldShowSunsetDisclaimer,
      isGbqEnabled,
      isHiddenChart,
      isTableOnly,
      rowOnFirstPage,
      endOfTable 
    } = this.props;
    const { chartData, valueLabel } = this.prepChartData();
    const { isDrillDownOpen, drillDownInfo } = this.state;
    const {
      trafficChannelsChart,
      trafficChannelsTable,
      keywordReportTable,
    } = showInReportConfig;

    const isTrafficGrandTotalDisplay = !inpdf || inpdf && page === endOfTable - 1;
    const isKeywordGrandTotalDisplay = !inpdf || inpdf && page === pageNumber - 1;
    const isBeginKeywordTable = !inpdf || (inpdf && page >= beginKeyword);
    const isFirstPDFPage = !inpdf || (inpdf && page === 0 && !isHiddenChart);
    let isDisplayChart = isFirstPDFPage;
    let isDisplayTable = inpdf ? isHiddenChart : true;
    let isDisplayKeywordTable;
    let showDeleteChartButton = false;
    let showDeleteTableButton = false;
    let showDeleteKeywordTableButton = false;
    if (isCustomReport) {
      isDisplayChart = trafficChannelsChart && isFirstPDFPage && (inpdf ? !isHiddenChart : true);
      isDisplayTable = trafficChannelsTable && (inpdf ? isHiddenChart : true);
      isDisplayKeywordTable = keywordReportTable;
      showDeleteChartButton = trafficChannelsChart;
      showDeleteTableButton = trafficChannelsTable;
      showDeleteKeywordTableButton = keywordReportTable;
    }
    const {
      trafficChannelsChart: chartCount,
      trafficChannelsTable: tableCount,
      keywordReportTable: keywordTableCount,
    } = countInReportConfig;
    const channelChartAndTableCount = getNumberOfChartAndTableInReport(chartCount, tableCount);
    const searchKeywordTableCount = getNumberOfChartAndTableInReport([], keywordTableCount);
    let filterKeywordTableColumnHashmap = DEFAULT_KEYWORD_DISPLAY_COLUMNS;
    const isShowTabDisclaimer = shouldShowTabDisclaimer({
      advertiser,
      campaign,
    });
    const isShowTabDisclaimerInDashboardOnly =
      !inpdf && !inTabReport && !isCustomReport && isShowTabDisclaimer;
    return (
      <div
        data-test="channelChart"
        className={cx(
          {
            [styles.channelsAnalyticsMainView]: !isCustomReport,
          },
          styles.channelsAnalytics,
        )}>
        {Array(channelChartAndTableCount).fill('').map((_item, index) => {
          const prefixKey = chartCount[index] ? 'channelChart' : 'channelTable';
          const key = chartCount[index] || tableCount[index] || (index + 1);
          const isDisplayChartInPreview = !!chartCount.find(item => item === index + 1) && (inpdf ? !isHiddenChart : true);
          isDisplayChart = isDisplayChartInPreview && isFirstPDFPage;
          isDisplayTable = !!tableCount.find(item => item === index + 1) && (!inpdf || !isBeginKeywordTable) && (inpdf ? isHiddenChart : true);
          const reportTypeSelector = get(channelChartSelectors, [index, 'type']);
          const chartSelectorType = reportTypeSelector || selectionType;
          const reportData = this.prepChartData(reportTypeSelector);
          const reportChartData  = get(reportData, 'chartData');
          const reportValueLabel = get(reportData, 'valueLabel');
          const isHideChannelFields = hideChannelFields || hideChannelFieldsForPdf;
          const isNewAdUsersSelected = chartSelectorType === newAdUsersKey;
          const dataConditions = {
            ...this.channelConditions,
            isNewAdUsersSelected
          }
          const filterTableColumnHashmap = getChannelDataHashmapByCondition(CHANNEL_TABLE_HASHMAP, dataConditions);
          const filterCsvColumnHashmap = getChannelCsvDataHashmapByCondition(CHANNEL_CSV_HASHMAP, dataConditions);
          const isDisplayChartContainer = !inpdf && (isDisplayChart || isDisplayTable) || inpdf && isDisplayChart;
          showDeleteChartButton = isCustomReport && isDisplayChart;
           // calculate number rows of table per page in pdf file
          const rowOnFirstPageInPdf = rowOnFirstPage || MIN_LENGTH_TRAFFIC_CHANNEL_DATA;
          let rowsPerTrafficPage = inpdf
          ? page === 0
            ? (isTrafficGrandTotalDisplay ? rowOnFirstPageInPdf : rowOnFirstPageInPdf + 1)
            : (isTrafficGrandTotalDisplay ? SINGLE_PAGE_WEB_ANALYTICS_DATA : SINGLE_PAGE_WEB_ANALYTICS_DATA + 1)
          : 0;
          return (
            <div
              key={prefixKey + key}
              className={cx({
                [ga4OnlyStyles.ga4DisclaimerWrapper]: isShowTabDisclaimerInDashboardOnly
              })}
            >
              {isShowTabDisclaimerInDashboardOnly && (
                <Fragment>
                  <div
                    className={cx({
                      [ga4OnlyStyles.mask]: isShowTabDisclaimerInDashboardOnly
                    })}
                  />
                  <div
                    className={cx({
                      [ga4OnlyStyles.ga4Disclaimer]: isShowTabDisclaimerInDashboardOnly
                    })}
                  >
                    <MessageWithStatus
                      type={INFO}
                      label={NOTE}
                      description={<DeprecatedDataDisclaimer tabName={'Channel'} />}
                      customStyle={{
                        toastContainer: ga4OnlyStyles.toastContainer,
                        toastContent: ga4OnlyStyles.toastContent,
                        typeIcon: ga4OnlyStyles.typeIcon
                      }}
                    />
                  </div>
                </Fragment>
              )}
              {
                isDisplayChartContainer && (
                  <Fragment>
                    {isDisplayChart &&
                      <ModuleExport
                        exportImg={this.exportContainer}
                        fileName={fileName}
                        disableCsvExport
                      />
                    }
                    <div ref={this.exportContainer} className={cx({[styles.deleteItemContainer]: currentStep === 'customize' && isDisplayChart}, styles.itemContainer)}>
                      {showDeleteChartButton &&
                        <DeleteReportItemButton
                          isDelete={showDeleteChartButton}
                          parentId="trafficChannels"
                          componentId="trafficChannelsChart"
                          customClassName={styles.deleteButton}
                          itemIndex={index}
                        />
                      }
                      <div className={styles.header}>
                        <div>{title}</div>
                        {
                          !isShowTabDisclaimerInDashboardOnly 
                          && isShouldShowSunsetDisclaimer 
                          && <UASunsetDisclaimer />
                        }
                      </div>
                      <div className={styles.containerDropdown}>
                        {this.drawDropDown(index, reportTypeSelector, this.handleTypeChange)}
                      </div>

                      {isDisplayChart &&
                        <div className={styles.contentContainer}>
                          <div className={styles.chartContainer}>
                            <div className={styles.chart}>
                            {chartSelectorType === avgAdCostKey ?
                              <ChannelsBarChart
                                data={reportChartData || chartData}
                                xAxisTitle={reportValueLabel || valueLabel}
                                isAvgCost
                                isGbqEnabled
                              />
                            :
                              <ChannelsPieChart
                                data={reportChartData || chartData}
                                valueLabel={reportValueLabel || valueLabel}
                                isPercentageDisabled={false}
                                isAdVisits
                              />
                            }
                            </div>
                          </div>
                          {shouldShowNewAdUserSunsetDisclaimer(
                            campaign,
                            isNewAdUsersSelected
                          ) && <NewAdUserSunsetDisclaimer />}
                        </div>
                      }
                    </div>
                  </Fragment>
                )
              }
              {isDisplayTable &&
                <div className={cx({[styles.deleteItemContainer]: currentStep === 'customize'}, styles.tableContainer, styles.itemContainer)}>
                  {showDeleteTableButton &&
                    <DeleteReportItemButton
                      isDelete={showDeleteTableButton}
                      parentId="trafficChannels"
                      componentId="trafficChannelsTable"
                      customClassName={styles.deleteButton}
                      itemIndex={index}
                    />
                  }
                  <ChannelsTable
                    data={data}
                    totalAds={totalAds}
                    avgAdCost={avgAdCost}
                    onCellClick={this.handleCellClick}
                    isAvgCostDisabled={isAvgCostDisabled}
                    inpdf={inpdf}
                    page={page}
                    numberPage={pageNumber}
                    rowsPerPage={rowsPerTrafficPage}
                    isGrandTotalDisplay={isTrafficGrandTotalDisplay}
                    hideChannelFields={isHideChannelFields}
                    isCustomReport={isCustomReport}
                    isDisplayChart={trafficChannelsChart}
                    itemIndex={index}
                    tableSortSelector={trafficTableSortSelector}
                    tableColumns={filterTableColumnHashmap}
                    csvColumns={filterCsvColumnHashmap}
                    isNewAdUsersSelected={dataConditions.isNewAdUsersSelected}
                    rowsFirstPage={rowOnFirstPage}
                  /> 
                </div>
              }
            </div>
          )
        })}
        {showKeywordTable && Array(searchKeywordTableCount).fill('').map((_item, index) => {
          const prefixKey = 'searchKeywordTable';
          const key = keywordTableCount[index] || (index + 1);
          const reportTypeSelector = get(keywordChartSelectors, [index, 'type']) || keywordSelectionType;
          const isNewAdUsersSelected = reportTypeSelector === newAdUsersKey;
          const dataConditions = {
            ...this.channelConditions,
            isNewAdUsersSelected
          }
          isDisplayKeywordTable = !!keywordTableCount.find(item => item === index + 1) && isBeginKeywordTable;
          filterKeywordTableColumnHashmap = getKeywordDataHashmapByConditions(KEYWORD_TABLE_HASHMAP, dataConditions);
          let rowsPerKeywordPage = 0;
          if (inpdf && isBeginKeywordTable) {
            const rowOnFirstPageInPdf = rowOnFirstPage || SINGLE_PAGE_WEB_ANALYTICS_DATA;
            rowsPerKeywordPage = isKeywordGrandTotalDisplay ? rowOnFirstPageInPdf : rowOnFirstPageInPdf + 1;
          }
          if (inpdf && isCustomReport) {
            if (isBeginKeywordTable) {
              rowsPerKeywordPage = rowsPerKeywordPage - COMMON_NUMBER_TABLE_ROWS_TO_TRUNCATE;
            }
          }

          return (
            <Fragment key={prefixKey+key}>
            {isDisplayKeywordTable && 
                <div className={cx({[styles.deleteItemContainer]: currentStep === 'customize'}, styles.tableContainer, styles.itemContainer)}>
                  {showDeleteKeywordTableButton &&
                    <DeleteReportItemButton
                      isDelete={showDeleteKeywordTableButton}
                      parentId="trafficChannels"
                      componentId="keywordReportTable"
                      customClassName={styles.deleteButton}
                      itemIndex={index}
                    />
                  }
                  <div className={styles.containerDropdown}>
                    {this.drawDropDown(index, reportTypeSelector, this.handleTypeChange, true)}
                  </div>
                  {isBeginKeywordTable && 
                    <Fragment>
                      {shouldShowNewAdUserSunsetDisclaimer(
                        campaign,
                        isNewAdUsersSelected
                      ) && (
                        <NewAdUserSunsetDisclaimer
                          customStyle={styles.keywordDisclaimer}
                        />
                      )}
                      <KeywordTable 
                        inpdf={inpdf}
                        data={keywordData}
                        page={page}
                        rowsPerPage={rowsPerKeywordPage}
                        beginKeyword={beginKeyword}   
                        isCustomReport={isCustomReport}
                        isGrandTotalDisplay={isKeywordGrandTotalDisplay}
                        tableSortSelector={keywordTableSortSelector}
                        itemIndex={index}
                        tableColumns={filterKeywordTableColumnHashmap}
                        isNewAdUsersSelected={dataConditions.isNewAdUsersSelected}
                        rowsFirstPage={rowOnFirstPage}
                      />
                    </Fragment>
                  }
                </div>
              }
            </Fragment>
          )
        })}
        <ShowAllAds
          open={isDrillDownOpen}
          detailUrl={drillDownInfo}
          detailInfo={drillDownInfo} //TODO: check what does this do
          onClose={this.handleDrillDownClose}
          campaign={campaign}
          advertiser={advertiser}
          id={TRAFFIC_CHANNEL_CHART_ID}
          currentChartId={TRAFFIC_CHANNEL_CHART_ID}
          notifications={notifications}
        />
      </div>
    )
  }
}

const muiStyle = {
  arrowDropDown: {
    color: '#2196f3'
  }
};

import { compose } from 'redux';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import getUrlApi from '../../../helpers/getUrlApi';
import { selectCurrentRoutePayload } from '../../../state/modules/routing';
import { redirectToCampaignTabs } from '../../../state/modules/routing/actions';
import { setChartSelector } from '../../../state/modules/app/campaign';
import { modules } from 'veritone-redux-common';
import { setReportChartSelector, setReportTableSortSelector } from '../../../state/modules/app/reportBuilder/actions';
import { NewAdUserSunsetDisclaimer, UASunsetDisclaimer } from '../ChartDisclaimer';

const { user : {
  selectUser
}} = modules;

const ChannelsAnalyticsSmartComponent = connect(
  (state, props) => {
    const { chartData, campaign, advertiser, reportBuilder, isCustomReport } = props;
    const { trackingDataSourceName } = advertiser;
    const isAdobeAdvertiser = trackingDataSourceName === TRACKING_SOURCE_NAME.ADOBE;
    const currentUser = selectUser(state);
    const data = get(chartData, [TRAFFIC_CHANNEL_CHART_ID, 'data'], []);
    const keywordData = get(chartData, [KEYWORD_CHART_ID, 'data', 'byKeyword'], []);
    const isAvgCostDisabled = get(chartData, 'avgAdCost') == null;
    const totalAds = get(chartData, 'totalAds', 0);
    const avgAdCost = get(chartData, 'avgAdCost', null);
    const attributeAppConfig = get(currentUser, 'organization.kvp.features.attribute') || {};
    const hideChannelFields = get(attributeAppConfig, 'hideChannelFields') === "enabled";
    const showKeywordTable = !isAdobeAdvertiser && (props.showKeywordTable || get(attributeAppConfig, 'keywordReport') === "enabled");
    const selectionType = get(campaign, ['chartSelector', TRAFFIC_CHANNEL_CHART_ID, 'type'], defaultDataType);
    const keywordSelectionType = get(campaign, ['chartSelector', KEYWORD_CHART_ID, 'type'], defaultDataType)
    const currentStep = get(state, 'reportBuilder.currentStep', '');
    const channelChartSelectors =  props.channelChartSelectors || get(state, ['reportBuilder', 'chartSelector', TRAFFIC_CHANNEL_CHART_ID], []);
    const keywordChartSelectors = props.keywordChartSelectors || get(state, ['reportBuilder', 'chartSelector', KEYWORD_CHART_ID], []);
    const enabledFlags = getEnabledFlags(props, state);
    const customReportDateRange = get(reportBuilder, 'reportProperties.reportDateRange');
    const isNewAdUserSelectorShow = isCustomReport ?    
                                    shouldShowTileByDateCompare({advertiser, campaign, customReportDateRange}) :
                                    shouldShowTileByDateCompare({advertiser, campaign});
    const isNewAdUsersEnabled = checkEnableFeatureFlag(enabledFlags, [newAdUsersMetricKey]) && isNewAdUserSelectorShow;
    const isGbqEnabled = checkEnableFeatureFlag(enabledFlags, ['googleBigQueryIngestion']);

    return {
      urlApi: getUrlApi(state),
      currentPayload: selectCurrentRoutePayload(state),
      data,
      totalAds,
      avgAdCost,
      isAvgCostDisabled,
      hideChannelFields,
      showKeywordTable,
      selectionType,
      currentStep,
      channelChartSelectors,
      keywordData,
      enabledFlags,
      isNewAdUsersEnabled,
      keywordChartSelectors,
      keywordSelectionType,
      isGbqEnabled,
    }
  },
  dispatch => ({
    redirectToCampaignTabs,
    setChartSelector: compose(dispatch, setChartSelector),
    setReportTableSortSelector: compose(dispatch, setReportTableSortSelector),
    setReportChartSelector: compose(dispatch, setReportChartSelector),
  })
)(withStyles(muiStyle)(ChannelsAnalytics));

export default ChannelsAnalyticsSmartComponent;